export enum CharacterizationTypeEnum {
  FunctionsPerformed = 1,
  TypeOfOption,
  Description,
}
